class UIUtils {
  static THROTTLE_TIME = 500; //milliseconds
  static lastEventTime = 0;

  static isScanEventAllowed() {
    let currentTime = new Date();
    if (currentTime - this.lastEventTime < this.THROTTLE_TIME) {
      return false;
    } else {
      this.lastEventTime = currentTime;
      return true;
    }
  }

  // Taken from https://meridian.a2z.com/fundamentals/layout/?platform=react-web
  static getDeviceType() {
    const screenWidth = window.innerWidth;
    return screenWidth >= 720 ? "DESKTOP" : "MOBILE";
  }
}

export default UIUtils;



// WEBPACK FOOTER //
// ./src/components/util/UIUtils.js